import { HTMLAttributes } from 'react'

import { Button, Heading, Text } from '@hhgtech/hhg-components'
import { Portal } from '@mantine/core'
import { useIntl } from 'react-intl'

import { redirectToSSOWithReturnUrl } from 'api/utils/redirects'
import { useCurrentUrl } from 'hooks/useCurrentUrl'

import { StyledPremiumContentBanner } from './index.styled'

const _PremiumContentBanner = ({
  haveClose = false,
  onClose,
  ...rest
}: Omit<PremiumContentBannerProps, 'isPortal'>) => {
  const { formatMessage: f } = useIntl()

  const toSSO = async () => {
    // await sendToSidis({action:""})
    redirectToSSOWithReturnUrl(window.location.href)
  }

  const currentUrl = useCurrentUrl()
  return (
    <StyledPremiumContentBanner {...rest}>
      {haveClose && (
        <div className="close-btn" role="button" onClick={onClose} tabIndex={0}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M3.99403 3.32719C3.86141 3.32723 3.73181 3.36681 3.62181 3.44089C3.5118 3.51497 3.42638 3.62017 3.37648 3.74304C3.32658 3.86592 3.31445 4.00088 3.34165 4.13068C3.36885 4.26049 3.43415 4.37923 3.52919 4.47173L7.05784 8.00037L3.52919 11.529C3.46521 11.5904 3.41413 11.664 3.37894 11.7454C3.34375 11.8269 3.32516 11.9145 3.32425 12.0032C3.32335 12.0919 3.34015 12.1799 3.37368 12.262C3.40721 12.3441 3.45678 12.4187 3.5195 12.4814C3.58222 12.5441 3.65682 12.5937 3.73894 12.6272C3.82106 12.6608 3.90904 12.6776 3.99774 12.6767C4.08643 12.6758 4.17405 12.6572 4.25547 12.622C4.33689 12.5868 4.41047 12.5357 4.4719 12.4717L8.00054 8.94308L11.5292 12.4717C11.5906 12.5357 11.6642 12.5868 11.7456 12.622C11.827 12.6572 11.9147 12.6758 12.0034 12.6767C12.092 12.6776 12.18 12.6608 12.2622 12.6272C12.3443 12.5937 12.4189 12.5441 12.4816 12.4814C12.5443 12.4187 12.5939 12.3441 12.6274 12.262C12.6609 12.1799 12.6777 12.0919 12.6768 12.0032C12.6759 11.9145 12.6573 11.8269 12.6222 11.7454C12.587 11.664 12.5359 11.5904 12.4719 11.529L8.94325 8.00037L12.4719 4.47173C12.5682 4.37808 12.634 4.25752 12.6607 4.12584C12.6873 3.99416 12.6735 3.85751 12.6212 3.73378C12.5688 3.61006 12.4803 3.50504 12.3672 3.43249C12.2542 3.35993 12.1218 3.32323 11.9875 3.32719C11.8143 3.33235 11.6499 3.40474 11.5292 3.52902L8.00054 7.05766L4.4719 3.52902C4.40977 3.46515 4.33548 3.41439 4.2534 3.37973C4.17132 3.34506 4.08313 3.3272 3.99403 3.32719V3.32719Z"
              fill="#595959"
            />
          </svg>
        </div>
      )}
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <circle cx="30" cy="30" r="30" fill="white" />
        <circle cx="30" cy="30" r="24" fill="#FFF8E2" />
        <circle cx="30" cy="30" r="16" fill="#FE921D" />
        <path
          d="M30 21C29.7348 21 29.4804 21.1054 29.2929 21.2929C29.1054 21.4804 29 21.7348 29 22C28.9998 22.1592 29.0376 22.3162 29.1103 22.4579C29.183 22.5995 29.2885 22.7218 29.418 22.8145L26.3457 27.1152L20.9473 25.3164C20.9818 25.2145 20.9996 25.1076 21 25C21 24.7348 20.8946 24.4804 20.7071 24.2929C20.5196 24.1054 20.2652 24 20 24C19.7348 24 19.4804 24.1054 19.2929 24.2929C19.1054 24.4804 19 24.7348 19 25C19 25.2652 19.1054 25.5196 19.2929 25.7071C19.4804 25.8946 19.7348 26 20 26C20.073 25.9995 20.1457 25.991 20.2168 25.9746L21.6523 32.4336C21.8553 33.3486 22.6665 34 23.6035 34H36.3945C37.3315 34 38.1447 33.3486 38.3477 32.4336L39.7832 25.9766C39.8544 25.9923 39.9271 26.0001 40 26C40.2652 26 40.5196 25.8946 40.7071 25.7071C40.8946 25.5196 41 25.2652 41 25C41 24.7348 40.8946 24.4804 40.7071 24.2929C40.5196 24.1054 40.2652 24 40 24C39.7348 24 39.4804 24.1054 39.2929 24.2929C39.1054 24.4804 39 24.7348 39 25C39.0004 25.1076 39.0182 25.2145 39.0527 25.3164L33.6543 27.1152L30.5801 22.8125C30.7096 22.7202 30.8153 22.5984 30.8884 22.4571C30.9614 22.3158 30.9997 22.1591 31 22C31 21.7348 30.8946 21.4804 30.7071 21.2929C30.5196 21.1054 30.2652 21 30 21ZM23 36C22.448 36 22 36.448 22 37C22 37.552 22.448 38 23 38H37C37.552 38 38 37.552 38 37C38 36.448 37.552 36 37 36H23Z"
          fill="white"
        />
      </svg>

      <div>
        <Heading tag="h4">
          {f({
            id: 'premiumBanner.title',
            defaultMessage: 'Get to the end of the story',
          })}
        </Heading>
        <Text size="p4">
          {f({
            id: 'premiumBanner.content',
            defaultMessage:
              'This article is available for the HelloBacsi member only. Please login or join now for getting the end of the story.',
          })}
        </Text>
      </div>
      <Button
        color="primary"
        size="md"
        className="btn pointer-event-child-none"
        onClick={() => toSSO()}
        data-event-category="Reading Full Text"
        data-event-action="Click"
        data-event-label={currentUrl}
      >
        {f({
          id: 'premiumBanner.button',
          defaultMessage: 'Log in / Join Now',
        })}
      </Button>
    </StyledPremiumContentBanner>
  )
}

type PremiumContentBannerProps = {
  isPortal?: boolean
  haveClose?: boolean
  onClose?(): void
} & HTMLAttributes<HTMLDivElement>
export const PremiumContentBanner = ({
  isPortal = true,
  ...rest
}: PremiumContentBannerProps) => {
  if (isPortal) {
    return (
      <Portal>
        <_PremiumContentBanner data-portal={isPortal} {...rest} />
      </Portal>
    )
  }
  return <_PremiumContentBanner data-portal={isPortal} {...rest} />
}
